import { render, staticRenderFns } from "./FpuiInputTags.vue?vue&type=template&id=072e4ec0&lang=pug&"
import script from "./FpuiInputTags.vue?vue&type=script&lang=js&"
export * from "./FpuiInputTags.vue?vue&type=script&lang=js&"
import style0 from "./FpuiInputTags.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports